module.exports = __webpack_public_path__ + "media/images/img-realestate-3-1ccc325d.png";